import { SvgCommonProperties } from '../../interfaces/svg.interfaces';

export interface BarChartSvgProps extends SvgCommonProperties {
  style: 'black-white' | 'stylish'
}

export default function BarChartSvg(props: BarChartSvgProps){
  let svg = undefined
  if(props.style === 'black-white'){
    svg = <svg 
        height={props.height}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 150"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
      <rect x="20" y="60" width="30" height="90" fill="black" />
      <rect x="70" y="30" width="30" height="120" fill="black" />
      <rect x="120" y="90" width="30" height="60" fill="black" />
    </svg>
  } else if(props.style === 'stylish'){
    svg = <svg 
        height={props.height}
        viewBox="0 0 200 150"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-6 h-6"
    >
      <rect x="20" y="60" width="30" height="90" fill="#3498db"/>
      <rect x="70" y="30" width="30" height="120" fill="#e74c3c"/>
      <rect x="120" y="90" width="30" height="60" fill="#2ecc71"/>
    </svg>
  }
  return svg
}